<usimweb-dropdown
  style="width: 250px"
  placeholder="Plot type"
  [values]="plotTypes"
  [key]="'key'"
  [value]="'value'"
  [default]="'filling'"
  [width]="'20%'"
  (selectionChange)="selectedPlotType($any($event))"
  [required]="true">
</usimweb-dropdown>

<usimweb-plot divId="plotDiv" [data]="plotData" [layout]="plotLayout"></usimweb-plot>
